(function () {
  angular.module("akitabox.dashboard").run(stateBlock);

  /* @ngInject */
  function stateBlock(Router) {
    Router.configureStates([
      {
        state: "app.dashboard",
        config: {
          url: "",
          templateUrl: "app/mobile/modules/dashboard/dashboard.html",
          data: {
            hideSideMenu: true,
            pageTitle: "Home",
          },
        },
      },
    ]);
  }
})();
